import API from 'utils/api';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';
import { onError, onSuccess } from 'utils/handlers';

export const baseURL = 'recaudacion/gastos';

export const patchCancelarGasto = async (id) => {
  try {
    const response = await API.patch(`${baseURL}/${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(null, 'Gasto cancelado correctamente');
    return response.data;
  } catch (error) {
    onError(error);
    return null;
  }
};

export const patchGasto = async (id, values) => {
  try {
    const response = await API.patch(`${baseURL}/${id}`, values);
    onSuccess(response, 'Gasto actualizado correctamente');
    return response.data;
  } catch (error) {
    onError(error);
    return null;
  }
};
